<template>
  <div>
    <v-row>
      <!--<editor-fold desc="Filters">-->
      <filters-column
        v-if="$can('manage-all')"
        :filters-active="filtersActive"
        @filters:clear-all="clearFilters()"
      >
        <v-subheader class="font-weight-medium">
          Type
        </v-subheader>
        <v-list
          rounded
          color="transparent"
          class="pa-0"
          dense
        >
          <v-list-item-group
            v-model="filters.type"
            class="ma-0"
          >
            <v-list-item
              class="mb-1"
              active-class="primary--text"
              value="playback"
            >
              <template v-slot:default="{ active, toggle }">
                <v-list-item-action>
                  <v-simple-checkbox
                    color="primary"
                    :value="active"
                    :ripple="false"
                    @click="toggle"
                  />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Playback
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
            <v-list-item
              class="mb-1"
              active-class="primary--text"
              value="system"
            >
              <template v-slot:default="{ active, toggle }">
                <v-list-item-action>
                  <v-simple-checkbox
                    color="primary"
                    :value="active"
                    :ripple="false"
                    @click="toggle"
                  />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    System
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <div v-if="filters.type === 'playback'">
          <v-subheader class="font-weight-medium">
            Playback Content
          </v-subheader>
          <v-list
            rounded
            color="transparent"
            class="pa-0"
            dense
          >
            <v-list-item-group
              v-model="filters.content_type"
              class="ma-0"
              multiple
            >
              <v-list-item
                class="mb-1"
                active-class="primary--text"
                value="playback"
              >
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-action>
                    <v-simple-checkbox
                      color="primary"
                      :value="active"
                      :ripple="false"
                      @click="toggle"
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Music regular
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
              <v-list-item
                class="mb-1"
                active-class="primary--text"
                value="powerplay"
              >
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-action>
                    <v-simple-checkbox
                      color="primary"
                      :value="active"
                      :ripple="false"
                      @click="toggle"
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Music powerplay
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
              <v-list-item
                class="mb-1"
                active-class="primary--text"
                value="advertisement"
              >
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-action>
                    <v-simple-checkbox
                      color="primary"
                      :value="active"
                      :ripple="false"
                      @click="toggle"
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Marketing
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
              <v-list-item
                class="mb-1"
                active-class="primary--text"
                value="public_announcement"
              >
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-action>
                    <v-simple-checkbox
                      color="primary"
                      :value="active"
                      :ripple="false"
                      @click="toggle"
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      PA
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>

        <v-subheader class="font-weight-medium">
          Time
        </v-subheader>
        <v-row no-gutters>
          <v-col cols="6">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="dateFrom ? $dayjs(dateFrom).format('DD.MM.YYYY.') : ''"
                  placeholder="01.01.2019."
                  outlined
                  label="From"
                  clearable
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="dateFrom = undefined; timeFrom = null"
                />
              </template>
              <v-date-picker
                v-model="dateFrom"
                @input="menu1 = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="6"
            class="pl-4"
          >
            <v-text-field
              v-model="timeFrom"
              v-mask="'##:##'"
              dense
              type="tel"
              outlined
              placeholder="00:00"
              clearable
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="dateTo ? $dayjs(dateTo).format('DD.MM.YYYY.') : ''"
                  placeholder="01.01.2019."
                  outlined
                  label="To"
                  clearable
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="dateTo = undefined; timeTo = null;"
                />
              </template>
              <v-date-picker
                v-model="dateTo"
                @input="menu2 = false"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="6"
            class="pl-4"
          >
            <v-text-field
              v-model="timeTo"
              v-mask="'##:##'"
              dense
              type="tel"
              outlined
              placeholder="00:00"
              clearable
            />
          </v-col>
        </v-row>
      </filters-column>
      <!--</editor-fold>-->

      <!--<editor-fold desc="Table">-->
      <v-col>
        <v-row
          no-gutters
          align="center"
        >
          <v-col>
            <pagination
              :page.sync="items.pagination.page"
              :last-page="items.meta.last_page"
              :total="items.meta.total"
              :from="items.meta.from"
              :to="items.meta.to"
              :total-visible="8"
              :show-counts="$can('manage-all')"
            />
          </v-col>
          <v-col
            v-if="$can('manage-all')"
            cols="auto"
          >
            <v-btn
              color="secondary"
              small
              text
              :href="exportUrl"
              target="_blank"
            >
              <v-icon
                left
                small
              >
                fa fa-download
              </v-icon>
              Export logs
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="items.data"
          :server-items-length="items.meta.total"
          :sort-by.sync="items.sorting.sortBy"
          :sort-desc.sync="items.sorting.desc"
          :page.sync="items.pagination.page"
          :items-per-page="items.pagination.perPage"
          :loading="items.loading"
          hide-default-footer
          disable-sort
          :mobile-breakpoint="0"
          class="v-data-table--striped elevation-15"
          @update:sort-by="fetchItems()"
          @update:page="fetchItems()"
        >
          <template v-slot:item="{ item: log }">
            <tr>
              <td>
                <v-chip
                  :color="eventSpecs[log.event].color"
                  outlined
                  small
                >
                  <v-avatar>
                    <v-icon
                      x-small
                    >
                      {{ eventSpecs[log.event].icon }}
                    </v-icon>
                  </v-avatar>
                  {{ eventSpecs[log.event].text }}
                </v-chip>
              </td>
              <td>
                <span v-if="log.library_file">
                  <span v-if="log.library_file.artist || log.library_file.title">
                    {{ log.library_file.artist + ' - ' }}{{ log.library_file.title }}
                  </span>
                  <span v-if="!log.library_file.artist || !log.library_file.title">
                    {{ log.library_file.original_file }}
                  </span>
                </span>
                <span
                  v-else
                  class="grey--text"
                >
                  -
                </span>
              </td>
              <td>
                <span v-if="log.user">
                  {{ log.user.name }}
                </span>
                <span
                  v-else
                  class="grey--text"
                >
                  -
                </span>
              </td>
              <td class="text-no-wrap">
                {{ $dayjs(log.created_at).format('DD.MM.YYYY. HH:mm:ss') }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="pa-2">
          <pagination
            :page.sync="items.pagination.page"
            :last-page="items.meta.last_page"
            :total="items.meta.total"
            :from="items.meta.from"
            :to="items.meta.to"
            :show-counts="$can('manage-all')"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import fetchableItemsMixin from '@/mixins/fetchableItemsMixin'
import FiltersColumn from '@/components/helpers/FiltersColumn'
import Players from '@/services/Players'
import PlayerLogModel from '@/models/PlayerLogModel'
import qs from 'qs'

export default {
  name: 'PlayerLog',
  components: {
    FiltersColumn
  },
  mixins: [fetchableItemsMixin],
  props: {
    player: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      menu1: false,
      menu2: false,
      dateFrom: null,
      dateTo: null,
      timeFrom: null,
      timeTo: null
    }
  },
  computed: {
    exportUrl() {
      const queryParams = {
        order_by: this.items.sorting.sortBy,
        order: this.items.sorting.desc ? 'desc' : 'asc',
        ...this.filters
      }

      return process.env.VUE_APP_API_URL + `/players/${this.player.id}/logs/download?` + qs.stringify(queryParams)
    }
  },
  watch: {
    dateFrom() {
      this.setDateFrom()
    },
    timeFrom() {
      this.setDateFrom()
    },
    dateTo() {
      this.setDateTo()
    },
    timeTo() {
      this.setDateTo()
    }
  },
  beforeCreate() {
    this.emptyFilters = PlayerLogModel.emptyFilters
  },
  created() {
    this.eventSpecs = PlayerLogModel.eventSpecs
    this.backendUrl = process.env.VUE_APP_API_URL

    if (this.$can('manage-all')) {
      this.headers = [
        { text: 'Event', value: 'event' },
        { text: 'Content', value: 'library_file_id' },
        { text: 'User', value: 'user_id' },
        { text: 'Time', value: 'last_sync_at' }
      ]
    } else {
      this.headers = [
        { text: 'Time', value: 'created_at' },
        { text: 'Event', value: 'event' }
      ]
    }

    this.fetchItems()
  },
  methods: {
    async itemsFetcher(queryParams) {
      return await Players.fetchLogs(this.player.id, queryParams)
    },
    setDateFrom() {
      if (!this.dateFrom) {
        this.timeFrom = null
        this.filters.date_from = undefined
        return
      }

      this.filters.date_from = this.dateFrom + (this.timeFrom ? ' ' + this.timeFrom + ':00' : '')
    },
    setDateTo() {
      if (!this.dateTo) {
        this.timeTo = null
        this.filters.date_to = undefined
        return
      }

      this.filters.date_to = this.dateTo + (this.timeTo ? ' ' + this.timeTo + ':00' : '')
    }
  }
}
</script>
